var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.articles)?_c('CarouselArticles',{attrs:{"articles":_vm.articles,"heading":"Åpenhetstiltak:"}}):_vm._e(),(_vm.posts)?_c('ListPosts',{attrs:{"posts":_vm.posts,"heading":"Nyeste blogginnlegg:","button":"Tidligere blogginnlegg","buttonTo":"blogg"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }